@if (solutionSpace$ | async; as solutionSpace) { @if (component$ | async; as component) {
<app-components-overview [links]="links" [component]="component" [solutionSpace]="solutionSpace">
</app-components-overview>
} }
